export default "__VITE_ASSET__6eafd3db__"